import classNames from "classnames"
import { AlertConfigurationModule } from "../types"
import { ThresholdType } from "@/api/AlertsService"
import DeviceType from "@/components/AlertSettingForms/DeviceType"
import Threshold from "@/components/AlertSettingForms/Threshold"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import { AlertThreshold } from "@/types/alert"
import { AlertConfigurationForm } from "@/types/alertConfigurations"

type VitalsSettingsProps = {
   disabled?: boolean
   loading: boolean
   updatingModule: string
   heartRateThreshold?: AlertThreshold
   respiratoryRateThreshold?: AlertThreshold
   wearableType?: boolean
   sensorType?: boolean
   handleSave: (
      state: Partial<AlertConfigurationForm>,
      configurationModule: AlertConfigurationModule
   ) => void
}

function VitalsSettings({
   disabled = false,
   loading,
   updatingModule,
   heartRateThreshold,
   respiratoryRateThreshold,
   wearableType,
   sensorType,
   handleSave,
}: VitalsSettingsProps) {
   return (
      <>
         <GridItem
            size={12}
            className={classNames({
               "alert-setting-detail__section--disabled": disabled,
            })}
         >
            <Grid flexWrap="nowrap">
               <DeviceType
                  loading={
                     loading &&
                     updatingModule ===
                        AlertConfigurationModule.SENSOR_TYPE_ENABLED
                  }
                  deviceType={{
                     wearables: wearableType ?? false,
                     sensors: sensorType ?? false,
                  }}
                  onSave={(state) =>
                     handleSave(
                        { sensorTypes: state },
                        AlertConfigurationModule.SENSOR_TYPE_ENABLED
                     )
                  }
               />
               <Threshold
                  type={ThresholdType.HEART_RATE}
                  loading={
                     loading &&
                     updatingModule === AlertConfigurationModule.HEART_RATE
                  }
                  form={heartRateThreshold}
                  sensorType={sensorType}
                  wearableType={wearableType}
                  onSave={(state) =>
                     handleSave(
                        { thresholds: [...state] },
                        AlertConfigurationModule.HEART_RATE
                     )
                  }
               />

               <Threshold
                  disabled={!sensorType}
                  type={ThresholdType.RESPIRATORY_RATE}
                  loading={
                     loading &&
                     updatingModule ===
                        AlertConfigurationModule.RESPIRATORY_RATE
                  }
                  form={respiratoryRateThreshold}
                  sensorType={sensorType}
                  wearableType={wearableType}
                  onSave={(state) =>
                     handleSave(
                        { thresholds: [...state] },
                        AlertConfigurationModule.RESPIRATORY_RATE
                     )
                  }
               />

               {/* <OxygenLevel
                     disabled={!wearableType}   
                     loading={
                        loading &&
                        updatingModule === AlertConfigurationModule.OXYGEN_LEVEL
                     }
                     form={oxygenLevel}
                     onSave={(state) =>
                        handleSave(
                           { oxygenLevel: state },
                           AlertConfigurationModule.OXYGEN_LEVEL
                        )
                     }
                  /> */}
            </Grid>
         </GridItem>
      </>
   )
}

export default VitalsSettings
